module.exports = __webpack_public_path__ + "img/UTOTTE-7.867f0b6e.jpg";